(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .directive('bottomLeftSchema',  bottomLeftSchemaInject);

  /** @ngInject */
  function bottomLeftSchemaInject() {
    var directive = {
      restrict: 'E',
      templateUrl: 'assets/schema/softWaterSubSystem-resized.svg',
      controller: BottomLeftSchemaController,
      controllerAs: 'vm',
      scope: {
        value: '='
      }
    };

    return directive;

    /** @ngInject */
    function BottomLeftSchemaController($scope, schemaUtils) {
      var vm = this;

      $scope.$watchGroup(['value.vent', 'value.highFloat', 'value.lowFloat', 'value.pressure', 'value.motor', 'value.motorError'], function (newValue) {
        vm.vent = newValue[0] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;
        vm.highFloat = newValue[1] ? schemaUtils.COLORS.highFloatWorking : schemaUtils.COLORS.highFloatNotWorking;
        vm.lowFloat = newValue[2] ? schemaUtils.COLORS.error : schemaUtils.COLORS.working;
        vm.pressure = newValue[3] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking;

        if (newValue[5]) {
          vm.motor = schemaUtils.COLORS.error;
        } else {
          vm.motor = newValue[4] ? schemaUtils.COLORS.working : schemaUtils.COLORS.notWorking
        }
      });
    }
  }

})();
